import { Helper } from "../core/util/helper";
import { Config } from "../core/config/config";
import { DialogHelper } from "../core/util/dialogHelper";
import { General } from "../../siteManagement/general";
import { HTTPService, JsonResultClass } from "../core/util/httpManager";
import { SheetEventType, Sheet } from "../../siteManagement/sheet";
import { Grid } from "../core/components/grid";
import { GridCustomToolBarButton, ToolBarStandardButton, ToolBarStandardButtonType } from "../core/components/toolBar";
import { Dialog, DialogProps } from "../core/components/dialog";
import { IsNumericTextBox } from "../core/components/isNumericTextBox";
import { TextBox } from "../core/components/textBox";
import { FieldInstance } from "../core/components/field";
import { ComponentHelper } from "../core/util/componentHelper";
import { EntityParts } from "./parts";
import React from "react"
///////////////////////////////////////////////////////////////////////////////
/////                                                                     /////                                 
/////                    Don't Touch my Garbage                           /////
/////                                                                     /////
///////////////////////////////////////////////////////////////////////////////

export default class EditAssemblyGroup extends React.Component<EditAssemblyGroupProps, EditAssemblyGroupState> {
    private translation: string[] = [];
    private sheet: Sheet = null;
    constructor(props: EditAssemblyGroupProps) {
        super(props);
        this.translation = this.props.translations;
        this.sheet = General.Sheet.Manager.getTopMostSheet();
        this.state = {
            assemblyGroup: props.entity.AssemblyGroup,
            selectedAssemblyGroup: props.entity.AssemblyGroup
        };
    }

    private triggerChange = () => {
        this.sheet.trigger(SheetEventType.Custom, { command: "assemblyGroupChange", assemblyGroup: this.state.assemblyGroup });
        this.props.onChange({ model: "" }, null);
    }

    private onSelect = (assemblyGroup: AssemblyGroup) => {
        this.setState({ selectedAssemblyGroup: assemblyGroup }, () => {
        });
    }

    private onDataChange = (assemblyGroup: AssemblyGroup) => {
        this.setState({ assemblyGroup: AssemblyGroupHelper.alignStructure(this.state.assemblyGroup, assemblyGroup) }, this.triggerChange)
    }

    private createTree = () => {
        return (
            <>
                <AssemblyTree
                    assemblyGroup={this.state.assemblyGroup}
                    onSelect={this.onSelect}
                />
            </>
        );
    }

    private createGrid = () => {
        
        return (
            <>
                <AssemblyGroupGrid
                    assemblyGroup={this.state.selectedAssemblyGroup}
                    onDataChange={this.onDataChange}
                    translations={this.translation}
                    canWrite={this.props.entity.RecordRight.CanWrite}
                />
            </>
        );
    }

    render() {
        const tree = this.createTree();
        const grid = this.createGrid();
        return (
            <div style={{ display: "flex", height: "100%", padding: "5px", paddingTop: "15px" }}>
                {tree}
                {grid}
            </div>
        );
    }
}

class AssemblyTree extends React.Component<AssemblyTreeProps, AssemblyTreeState> {
    private assemblyGroupCopy: AssemblyGroup = null;
    private treeData = null;
    private tree: JQuery<HTMLElement> = null;
    private flat: { id: string, assemblyGroup: AssemblyGroup }[] = [];
    private treeDiv: HTMLDivElement;
    constructor(props: AssemblyTreeProps) {
        super(props);
        this.createCopy();
        this.treeData = [this.mapToTreeStructure(this.props.assemblyGroup)];
        this.state = {
            id: this.treeData[0].id
        }
    }

    private createCopy = () => {
        this.assemblyGroupCopy = JSON.parse(JSON.stringify(this.props.assemblyGroup));
    }

    private mapToTreeStructure(assemblyGroup: AssemblyGroup): AssemblyTreeStructure {
        let expanded = true;
        let isNew = true;
        let id = kendo.guid();
        let item = this.flat.find(f => f.assemblyGroup.ArtNr === assemblyGroup.ArtNr
            && f.assemblyGroup.Pos === assemblyGroup.Pos
            && f.assemblyGroup.Level === assemblyGroup.Level
            && f.assemblyGroup.RefArtNr === assemblyGroup.RefArtNr
        );
        if (Helper.hasValue(item) && this.tree != null) {
            let treeview = this.tree.data("kendoTreeView");
            let treeItem = treeview.dataSource.get(item.id);
            if (Helper.hasValue(treeItem)) {
                expanded = treeItem["expanded"];
            }
            id = item.id;
            isNew = false;
        }
        let amountTemplate = "";
        if (Helper.hasValue(assemblyGroup.RefArtNr) && Helper.hasValue(assemblyGroup.Amount)) {
            amountTemplate += " - " + assemblyGroup.Amount.toLocaleString() + " " + (Helper.isNullOrEmpty(assemblyGroup.Unit) ? "x" : assemblyGroup.Unit)
        }
        if (isNew) {
            this.flat.push({
                id: id,
                assemblyGroup: assemblyGroup
            });
        }
        
        let nameTemplate = "";
        if (!Helper.isNullOrEmpty(assemblyGroup.Name))
            nameTemplate = " - " + assemblyGroup.Name;
        return {
            expanded: expanded,
            id: id,
            text: assemblyGroup.Artikelnummer + nameTemplate + amountTemplate,
            spriteCssClass: null,
            items: assemblyGroup.Items.map((item: AssemblyGroup) => {
                return this.mapToTreeStructure(item);
            })
        }
    }

    private distinctFlatList = () => {
        let treeview = this.tree.data("kendoTreeView");
        let ids = this.flat.map((item) => {
            return item.id;
        });
        ids.forEach((id) => {
            if (!Helper.hasValue(treeview.dataSource.get(id))) {
                this.flat = this.flat.filter(f => f.id !== id);
            }
        });
    }

    private onSelect = (e) => {
        let id: string = $(this.treeDiv).data('kendoTreeView').dataItem(e.node).id;
        this.setState({ id: id }, () => { this.props.onSelect(this.flat.find(f => f.id === id).assemblyGroup) });
    }

    private initTree = () => {
        this.tree.kendoTreeView({
            dataSource: this.treeData,
            select: this.onSelect
        });
        this.setState({}, () => { this.setSelect() });
    }

    private setSelect = (id: string = null) => {
        if (Helper.isNullOrEmpty(id)) {
            id = this.treeData[0].id;
        }
        let treeview = this.tree.data("kendoTreeView");
        let getItem = treeview.dataSource.get(id);
        treeview.findByUid(getItem.uid);
        let selectItem = treeview.findByUid(getItem.uid);
        treeview.select(selectItem);
    }

    private updateTree = () => {
        this.treeData = [this.mapToTreeStructure(this.props.assemblyGroup)];
        this.tree.data("kendoTreeView").setDataSource(this.treeData);
        this.setSelect(this.state.id);
        this.distinctFlatList();
    }

    componentDidUpdate() {
        if (this.assemblyGroupChanged(this.props.assemblyGroup)) {
            this.createCopy();
            this.updateTree();
        }
    }

    private assemblyGroupChanged = (newAssemblyGroup: AssemblyGroup): boolean => {
        let oldAG = JSON.stringify(this.assemblyGroupCopy);
        let newAG = JSON.stringify(newAssemblyGroup);
        return (oldAG !== newAG)
    }

    componentDidMount() {
        this.tree = $(this.treeDiv);
        this.initTree();
    }

    render() {
        return (
            <div style={{ width: "100%" }}>
                <div style={{ height: "100%" }} ref={(ref) => { this.treeDiv = ref; }} id="treeview"></div>
            </div>
        );
    }

}

class AssemblyGroupGrid extends React.Component<AssemblyGroupGridProps, AssemblyGroupGridState> {
    private factory = ComponentHelper.createFactory();
    private gridOptions: kendo.ui.GridOptions = null;
    private standardButtons: Array<ToolBarStandardButton> = null;
    private itemCopy: AssemblyGroup = null;
    private dialogProps: DialogProps = {
        title: Config.translations.editLabel,
        actions: [
            {
                label: Config.translations.cancel,
                action: () => {
                    this.setState({ selectedItem: this.itemCopy });
                }
            },
            {
                label: Config.translations.ok,
                action: () => {
                    HTTPService.post<JsonResultClass<AssemblyGroup[]>>("Parts/UpdateAssemblyGroupPart", {
                        assemblyGroupPart: this.state.selectedItem
                    }).then(result => {
                        if(result.Code == 0)
                        {
                            // todo: closeDialog, updateTree (für den Fall, dass die Baugruppe this.state.selectedItem.RefArtNr mehrmals im Baum ist.
                        }
                    });
                },
                primary: true
            }
        ],
        afterClose: () => {
            this.closeDialog()
        },
        width: 500
    };
    constructor(props: AssemblyGroupGridProps) {
        super(props);
        this.state = {
            gridData: props.assemblyGroup.Items,
            selectedItem: null,
            dialogOpen: false
        }
        this.initGrid()
    }

    private onDataChange = () => {
        let assemblyGroup = this.props.assemblyGroup;
        assemblyGroup.Items = this.state.gridData;
        this.props.onDataChange(assemblyGroup);
    }

    private initGrid = () => {
        this.gridOptions = {
            sortable: false,
            pageable: false,
            groupable: false,
            filterable: false,
            selectable: true,
            resizable: true,
            scrollable: true,
            columns: [
                {
                    field: "Artikelnummer",
                    title: this.props.translations["Field.Material.artikelnummer"]
                },
                {
                    field: "Name",
                    title: this.props.translations["Field.Material.bezeichnung"]
                },
                {
                    field: "Amount",
                    title: this.props.translations["Parts.ChargenSerien.Menge"]
                }
            ]
        };
    }

    private createGrid = () => {
        
        const index = Helper.hasValue(this.state.selectedItem) ? this.state.gridData.findIndex(f => f.ArtNr == this.state.selectedItem.ArtNr && f.Pos == this.state.selectedItem.Pos) : -1;
        const enabled = this.props.canWrite && Helper.hasValue(this.props.assemblyGroup) && this.props.assemblyGroup.Level == 0;
        const standardButtons = [
            {
                type: ToolBarStandardButtonType.NEW,
                caption: this.props.translations["WebSMS.Reminder.Add"],
                enabled: enabled
            },
            {
                type: ToolBarStandardButtonType.EDIT,
                caption: Config.translations.editLabel,
                enabled: enabled
            },
            {
                type: ToolBarStandardButtonType.DELETE,
                caption: this.props.translations["Standard.Entfernen"],
                enabled: enabled
            }
        ];

        const translation = Helper.getTranslation("Standard.OpenX");

        const customButtons: Array<GridCustomToolBarButton> = [
            {
                autoEnabledOnRecordSelected: true,
                caption: Helper.hasValue(this.state.selectedItem) ? translation.replace("{x}", this.state.selectedItem.Name) : Helper.getTranslation("Standard.Öffnen"),
                enabled: true,
                iconClass: "k-i-redo",
                id: "openArticle"
            },
            {
                autoEnabledOnRecordSelected: false,
                caption: !Helper.isNullOrEmpty(this.props.assemblyGroup.Name) ? translation.replace("{x}", this.props.assemblyGroup.Name) : Helper.getTranslation("Standard.OpenMain"),
                enabled: this.props.assemblyGroup.Level > 0,
                iconClass: "k-i-redo",
                id: "openRoot"
            },
            {
                autoEnabledOnRecordSelected: true,
                caption: this.props.translations["Standard.Up"],
                enabled: index != -1 && index > 0 && enabled,
                iconClass: "k-i-arrow-60-up",
                id: "articleUp"
            },
            {
                autoEnabledOnRecordSelected: true,
                caption: this.props.translations["Standard.Down"],
                enabled: index != -1 && index < this.state.gridData.length - 1 && enabled,
                iconClass: "k-i-arrow-60-down",
                id: "articleDown"
            }
        ];
        let grid = (
            <Grid data={this.state.gridData}
                options={this.gridOptions}
                id="AssemblyGroupsGrid"
                standardButtons={standardButtons}
                onClickStandardButton={this.onClickStandardButton}
                customButtons={customButtons}
                onClickCustomButton={this.onClickCustomButton}
                onSelectionChanged={this.onSelectionChanged}
                selectFilter={Helper.hasValue(this.state.selectedItem) ? this.state.selectedItem.Artikelnummer : null}
            />
        );
        return (
            <div style={{ width: "100%" }}>
                {grid}
            </div>
        )

    }

    private createDialog = () => {
        //{ this.createDescriptionTextBox() }

        return (
            <div>
                <Dialog {...this.dialogProps} open={true}>
                    {this.createNumericTextBox()}
                </Dialog>
            </div>
        );
    }

    private createNumericTextBox = () => {
        let props = this.factory.getDefaultNumericTextBoxProps();
        props.value = this.state.selectedItem.Amount;
        props.field.min = 0;
        props.onChange = (field: { model: string }, value: number, dataItem?: any) => {
            let selectedItem = this.state.selectedItem;
            selectedItem.Amount = value;
            this.setState({ selectedItem: selectedItem }, this.onDataChange);
        }

        return (
            <FieldInstance label={this.props.translations["Parts.ChargenSerien.Menge"]} noHover={true}>
                <IsNumericTextBox {...props} />
            </FieldInstance>
        );
    }

    private createDescriptionTextBox = () => {
        let props = this.factory.getDefaultTextBoxProps();
        props.value = this.state.selectedItem.Description;
        props.onChange = (field: { model: string }, value: string, dataItem?: any) => {
            let selectedItem = this.state.selectedItem;
            selectedItem.Description = value;
            this.setState({ selectedItem: selectedItem }, this.onDataChange);
        }

        return (
            <FieldInstance label={this.props.translations["Standard.Beschreibung"]} noHover={true}>
                <TextBox {...props} />
            </FieldInstance>
        );
    }

    private onSelectionChanged = (dataItem: AssemblyGroup) => {
        this.setState({ selectedItem: dataItem });
    }

    private onClickStandardButton = (type: ToolBarStandardButtonType, dataItem: AssemblyGroup) => {
        switch (type) {
            case ToolBarStandardButtonType.NEW:
                this.addNewArticle();
                break;
            case ToolBarStandardButtonType.DELETE:
                this.removeArticle(dataItem);
                break;
            case ToolBarStandardButtonType.EDIT:
                this.openDialog(dataItem);
                break;
        }
    }

    private onClickCustomButton = (id: string, dataItem: AssemblyGroup) => {
        switch (id) {
            case "articleUp":
                this.switch(dataItem.Pos, dataItem.Pos - 1);
                break;
            case "articleDown":
                this.switch(dataItem.Pos, dataItem.Pos + 1);
                break;
            case "openArticle":
                this.openArticle(dataItem);
                break;
            case "openRoot":
                this.openArticle(this.props.assemblyGroup)
                break;
        }
    }

    private addNewArticle = () => {
        const url: string = "DynamicSearch/Window/assemblyParts?cus_ArtNrs=" + JSON.stringify(this.getBannedArticles()) + "&multi=true&displayPattern=[[artikelnummer]]";
        const sheet = General.Sheet.Manager.createSheetWithUrl(url, {}, {}, true);
        sheet.bind(SheetEventType.ItemsSelected, async (data: { data: { artnr: number }[] }) => {
            let result = await HTTPService.post<JsonResultClass<AssemblyGroup[]>>("Parts/AddPartsToAssemblyGroup", { 
                assemblyGroupNr: this.props.assemblyGroup.ArtNr,
                artNrs: data.data.map((item) => {
                    return item.artnr
                })
            });
            if (result.Code == 0) {
                let gridData = this.state.gridData;
                result.Data.forEach((item) => {
                    item.Amount = 1;
                    gridData.push(AssemblyGroupHelper.restructure(item, this.props.assemblyGroup.Level + 1, this.props.assemblyGroup.ArtNr, this.props.assemblyGroup.Path));
                });
                this.setState({ gridData: gridData }, this.onDataChange);
            }
        });
    }

    private getBannedArticles = (): number[] => {
        let lst: number[] = this.state.gridData.map((item: AssemblyGroup) => {
            return item.ArtNr;
        })
        lst.push(this.props.assemblyGroup.ArtNr)
        let path = this.props.assemblyGroup.Path.split('.').map((artNr) => {
            let c = Number(artNr);
            return Number.isNaN(c) ? null : c;
        }).filter(f => Helper.hasValue(f));

        let result = [...lst, ...path];
        return (result.filter((item, pos) => result.indexOf(item) === pos));
    }

    private removeArticle = async (dataItem: AssemblyGroup) => {
        let isOk = await DialogHelper.confirm(this.props.translations["Standard.Msg.Loeschen"]);
        if (!isOk) return;
        
        let result = await HTTPService.post<JsonResultClass<AssemblyGroup[]>>("Parts/RemovePartFromAssemblyGroup", {
            assemblyGroupNr: dataItem.RefArtNr,
            partNr: dataItem.ArtNr,
            pos: dataItem.Pos
        });
        if (result.Code != 0) return;
        
        let gridData = this.state.gridData.filter(f => f.ArtNr !== dataItem.ArtNr && f.Pos !== dataItem.Pos);
        this.setState({gridData: gridData, selectedItem: null}, this.onDataChange);
    }

    private switch = async (pos1: number, direction: number) => {
        let gridData = this.state.gridData;
        
        let index1 = gridData.findIndex(f => f.Pos === pos1);
        let index2: number;
        if (direction < pos1)
            index2 = index1 - 1;
        else 
            index2 = index1 + 1;
        
        let item1 = this.state.gridData[index1];
        let item2 = this.state.gridData[index2];
        
        let result = await HTTPService.post<JsonResultClass>("Parts/ExchangeAssemblyGroupParts", {
            assemblyGroupNr: item1.RefArtNr,
            pos1: item1.Pos,
            pos2: item2.Pos
        });
        if(result.Code !== 0)
            return;
        
        let tmp = this.state.gridData[index1];
        gridData[index1] = gridData[index2];
        gridData[index2] = tmp;
        this.setState({ gridData: gridData }, this.onDataChange);
    }

    private openArticle = (dataItem: AssemblyGroup) => {
        const url: string = Config.baseUrl + "Parts/Edit?id=" + dataItem.ArtNr;
        Helper.openInNewBrowserTab(url);
        //const sheet = General.Sheet.Manager.createSheetWithUrl(url, {}, {}, true);
        //sheet.bind(SheetEventType.Close, (data: any) => {
        //});
    }

    private openDialog = (dataItem: AssemblyGroup) => {
        this.itemCopy = JSON.parse(JSON.stringify(dataItem));
        this.setState({ dialogOpen: true, selectedItem: dataItem })
    }

    private closeDialog = () => {
        let gridData = this.state.gridData;
        let index = gridData.findIndex(f => f.ArtNr === this.state.selectedItem.ArtNr && f.Pos === this.state.selectedItem.Pos);
        gridData[index] = this.state.selectedItem;
        this.setState({ dialogOpen: false, gridData: gridData }, this.onDataChange)
    }

    componentDidUpdate(prevProps: AssemblyGroupGridProps) {
        let sameItem = (prevProps.assemblyGroup.ArtNr === this.props.assemblyGroup.ArtNr && prevProps.assemblyGroup.RefArtNr === this.props.assemblyGroup.RefArtNr && prevProps.assemblyGroup.Level === this.props.assemblyGroup.Level);
        if (!sameItem) {
            this.setState({ gridData: this.props.assemblyGroup.Items })
        }
    }

    render() {
        const grid = this.createGrid();
        const dialog = this.state.dialogOpen ? this.createDialog() : null;
        return (
            <>
                {grid}
                {dialog}
            </>
        );
    }

}

class AssemblyGroupHelper {

    public static copy = (assemblyGroup: AssemblyGroup): AssemblyGroup => {
        return JSON.parse(JSON.stringify(assemblyGroup));
    }

    public static restructure = (assemblyGroup: AssemblyGroup, level: number, refArtNr: number, path: string): AssemblyGroup => {
        let ag = AssemblyGroupHelper.copy(assemblyGroup);
        //ag.Amount = 1;
        ag.Level = level;
        ag.RefArtNr = refArtNr;
        ag.Path = AssemblyGroupHelper.cleanPath(path + "." + assemblyGroup.ArtNr);
        for (let i = 0; i < assemblyGroup.Items.length; i++) {
            ag.Items[i] = AssemblyGroupHelper.restructure(ag.Items[i], level + 1, assemblyGroup.ArtNr, ag.Path)
        }
        return ag;
    }

    public static alignStructure = (assemblyGroup: AssemblyGroup, updatedItem: AssemblyGroup): AssemblyGroup => {
        let ag: AssemblyGroup = AssemblyGroupHelper.copy(assemblyGroup);
        if (assemblyGroup.ArtNr === updatedItem.ArtNr) {
            ag = AssemblyGroupHelper.restructure(updatedItem, assemblyGroup.Level, assemblyGroup.RefArtNr, assemblyGroup.Path);
        } else {
            for (let i = 0; i < ag.Items.length; i++) {
                ag.Items[i] = AssemblyGroupHelper.alignStructure(ag.Items[i], updatedItem)
            }
        }
        return ag;
    }

    public static cleanPath = (path: string) => {
        let distincted = path.split(".").filter((elem, pos, arr) => {
            return arr.indexOf(elem) == pos;
        });

        let result: string = "";
        for (let i = 0; i < distincted.length; i++) {
            result += distincted[i].toString();
            if (i < distincted.length - 1) {
                result += ".";
            }
        }
        return result;
    }
}

interface EditAssemblyGroupProps {
    entity: EntityParts;
    onChange: (field, value) => void;
    translations: string[];
}

interface EditAssemblyGroupState {
    assemblyGroup: AssemblyGroup;
    selectedAssemblyGroup: AssemblyGroup;
}

interface AssemblyTreeProps {
    assemblyGroup: AssemblyGroup;
    onSelect: (assemblyGroup: AssemblyGroup) => void;
}

interface AssemblyTreeState {
    id: string;
}

interface AssemblyGroupGridProps {
    assemblyGroup: AssemblyGroup;
    translations: string[];
    onDataChange: (AssemblyGroup: AssemblyGroup) => void;
    canWrite: boolean;
}

interface AssemblyGroupGridState {
    gridData: AssemblyGroup[];
    selectedItem: AssemblyGroup;
    dialogOpen: boolean;
}

interface AssemblyTreeStructure {
    id: string;
    text: string;
    expanded: boolean;
    spriteCssClass: string;
    items: AssemblyTreeStructure[];
}

export interface AssemblyGroup {
    ArtNr: number;
    Artikelnummer: string;
    Pos: number;
    Name: string;
    Amount: number;
    Unit: string;
    Items: AssemblyGroup[];
    Level: number;
    RefArtNr: number;
    Path: string;
    Price: number;
    Description: string;
}